module.exports = __webpack_public_path__ + "prod/1.42.2/img/msg3.f38eb721.png";